<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_vii"></a>2012</p>
<p class="sub-title1"><span class="smallcaps">THE WAR FOR SOULS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?da1a27ba